module.exports = __webpack_public_path__ + "static/media/0301.3b567bf4.png";